import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

interface Transaction {
  id: string | number;
  date: string;
  receiptId: string;
  plan: string;
  user?: string;
}

interface TransactionHistoryProps {
  hideUserColumn?: boolean;
  transactions?: Transaction[];
}

const TransactionHistory: React.FC<TransactionHistoryProps> = ({ hideUserColumn, transactions: propTransactions }) => {
  const navigate = useNavigate();
  const defaultTransactions: Transaction[] = [
    {
      id: 1,
      date: "17 Feb, 2025 14:53",
      user: "Sophia Williams",
      receiptId: "1009826",
      plan: "Premium",
    },
    {
      id: 2,
      date: "24 Mar, 2025 12:53",
      user: "Liam Brown",
      receiptId: "529826",
      plan: "Basic",
    },
    {
      id: 3,
      date: "16 Jan, 2025 11:24",
      user: "John Smith",
      receiptId: "1009826",
      plan: "Premium",
    },
    {
      id: 4,
      date: "08 Jul, 2025 14:53",
      user: "Emily Davis",
      receiptId: "5409826",
      plan: "Free",
    },
    {
      id: 5,
      date: "17 Feb, 2025 14:53",
      user: "David Miller",
      receiptId: "1009826",
      plan: "Premium",
    },
    {
      id: 6,
      date: "08 Jul, 2025 14:53",
      user: "Olivia Johnson",
      receiptId: "5409826",
      plan: "Basic",
    },
  ];
  
  const transactions = propTransactions || defaultTransactions;

  return (
    <TableContainer className="table_container">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Receipt ID</TableCell>
            <TableCell>Transaction Date</TableCell>
            {!hideUserColumn && <TableCell>User</TableCell>}
            <TableCell>Plan</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {transactions.map((tx) => (
            <TableRow key={tx.id}>
              <TableCell>{tx.receiptId}</TableCell>
              <TableCell>{tx.date}</TableCell>
              {!hideUserColumn && (
                <TableCell>
                  <Box component="a" onClick={(e) => {
                    e.preventDefault();
                    navigate("/manage-users/detail");
                  }}
                    className="user_block click_action">
                    <p> <b> {tx.user}</b> <span>9876543210</span> <span>john@yopmail.com</span> </p>
                  </Box>
                </TableCell>
              )}
              <TableCell>{tx.plan}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TransactionHistory;
